<template>
  <b-modal id="modal-cadastrar" dialog-class="modal-conta" size="lg" hide-footer :no-enforce-focus="true">
    <template slot="modal-header">
      <h5 class="modal-title" v-if="turmaEdicao">Editar turma</h5>
      <h5 class="modal-title" v-else>Cadastrar turma</h5>
      <button type="button" class="close" aria-label="Close" @click="$bvModal.hide('modal-cadastrar')">
        <span aria-hidden="true">&times;</span>
      </button>
    </template>
    <form>
      <div class="row">
        <div class="col-12">
          <form-group id="nome" label="Nome *" :text="{ required: 'Obrigatório informar o nome do turma' }" :field="$v.turma.nome">
            <input type="text" class="form-control" id="nome" v-model="turma.nome"/>
          </form-group>
        </div>
        <div class="col-12">
          <form-group id="codigo" label="Código *" :text="{ required: 'Obrigatório informar o código do turma' }" :field="$v.turma.codigo">
            <input type="text" class="form-control" id="codigo" v-model="turma.codigo"/>
          </form-group>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label for="turma">Tutores</label>
            <multiselect v-model="turma.tutoresSelecionados"
              :options="tutores"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              :show-labels="false"
              label="nome"
              track-by="id"
              placeholder="Selecione um ou mais tutores"
              select-label="Selecionar tutor"
              deselect-label="Remover tutor"
              selected-label="Tutor selecionado"
              :preselect-first="false"
              :block-keys="['Tab','Enter']">
              <span slot="noResult">Nenhum tutor encontrado.</span>
              <span slot="noOptions">A lista está vazia.</span>
              <template slot="selection" slot-scope="{ values, search, isOpen }">
                <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} tutores selecionados</span>
              </template>
            </multiselect>
          </div>
        </div>
      </div>
      <div class="text-center">
        <div class="d-flex align-items-center justify-content-center mt-4 mb-4">
          <button class="btn btn-primary mr-3" type="button" @click="salvarTurma">Salvar</button>
          <a href="javascript:void(0)" class="btn btn-secondary" @click="$bvModal.hide('modal-cadastrar')">Cancelar</a>
        </div>
      </div>
    </form>
  </b-modal>
</template>

<script>
import Swal from 'sweetalert2'
import TurmaAPI from '@/api/turma-api'
import { required } from 'vuelidate/lib/validators'
import FormGroup from '@/core/components/FormGroup'
import ResponseUtils from '@/core/util/response-utils'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

export default {
  name: 'ModalCadastroTurma',
  components: {
    FormGroup,
    Multiselect
  },
  props: {
    turmaEdicao: Object,
    tutores: Array
  },
  data () {
    return {
      turma: {
        nome: '',
        codigo: '',
        tutoresSelecionados: []
      }
    }
  },
  mounted () {
    this.$root.$on('bv::modal::show', () => {
      this.$v.$reset()
      this.turma.tutoresSelecionados = []
      if (this.turmaEdicao) {
        Object.assign(this.turma, this.turmaEdicao, {
          tutoresSelecionados: this.turmaEdicao.tutores
        })
      } else {
        this.turma = {
          nome: '',
          codigo: '',
          tutoresSelecionados: []
        }
      }
    })
  },
  validations: {
    turma: {
      nome: { required },
      codigo: { required }
    }
  },
  methods: {
    show: function () {
      this.$bvModal.show('modal-cadastrar')
    },
    salvarTurma: function () {
      this.$v.turma.$touch()
      if (!this.$v.turma.$invalid) {
        const loader = this.$loading.show()
        if (this.turmaEdicao) {
          TurmaAPI.editar(this.turma).then(data => {
            loader.hide()
            Swal.fire({
              icon: 'success',
              showCloseButton: true,
              text: 'Turma editado com sucesso'
            }).then(() => {
              this.$bvModal.hide('modal-cadastrar')
              this.$emit('turmaSalvo', this.turma)
            })
          }).catch(error => ResponseUtils.handleError(error, loader))
        } else {
          TurmaAPI.cadastrar(this.turma).then(data => {
            loader.hide()
            Swal.fire({
              icon: 'success',
              showCloseButton: true,
              text: 'Turma cadastrado com sucesso'
            }).then(() => {
              this.$bvModal.hide('modal-cadastrar')
              this.$emit('turmaSalvo', this.turma)
            })
          }).catch(error => ResponseUtils.handleError(error, loader))
        }
      }
    }
  }
}
</script>
